import Cookies from "js-cookie";
import store from '@/store/index.js';
export default {
    name: 'Guard',
    auth(){
        
        var token = Cookies.get('_mysapp_token');
        
      //ajax para o backend pra checar o token
        if(token){
          fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_CHECKTOKEN}`, {
              method:'POST',
              headers:{
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization' : 'Bearer ' + token
              },
              
          }).then(response => response.json())
          .then(res => {
              
              if(res.status == 'ok'){
                  store.commit('SET_AUTHENTICADED', true);
                  store.commit('SET_USER', res.user);
              }else{
                  Cookies.remove('_mysapp_token')
                  store.commit('SET_AUTHENTICADED', false);
              }
          }).catch(() => { 
            store.commit('SET_AUTHENTICADED', false);
          });
        }else{
            store.commit('SET_AUTHENTICADED', false);
        }
    }
    // auth(to, from, next){
    //     var token = Cookie.get('_mysapp_token');
        
    //     //ajax para o backend pra checar o token
    //     if(token){
    //         fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_CHECKTOKEN}`, {
    //             method:'POST',
    //             headers:{
    //                 'Content-Type': 'application/json',
    //                 'Accept': 'application/json',
    //                 'Authorization' : 'Bearer ' + token
    //             },
                
    //         }).then(response => response.json())
    //         .then(res => {
                
    //             if(res.status == 'ok'){
    //                 next();
    //             }else{
    //                 Cookie.remove('_mysapp_token')
    //                 next('/');
    //             }
    //         }).catch(() => { 
    //             next('/');
    //         });
    //     }else{
    //         next('/');
    //     }
    // }
    
}